export default __webpack_public_path__ + "static/media/disc-guide.46a6dd79.png";